export const APIBoardSessionColumnExportList = [
    'status', //'Status'
    'school_name', // 'SchoolName'
    'firstName', //'TeacherFirstName',
    'lastName', // 'TeacherLastName'
    'classCode', // 'ClassCode/Grouping'
    'students', // 'Students'
    'startTime', // 'StartTime'
    'submissions',
];